import get from 'lodash/get';
import DepsService from 'services/dependencies';
import appHelpers from 'app/app-helpers';

export const PRICES_PAID_WTD_ID = 'cumulativeWinnersAwarenessWeek';
export const PRICES_PAID_MTD_ID = 'cumulativeWinnersAwarenessMonth';
export const PRICES_PAID_YTD_ID = 'cumulativeWinnersAwarenessYear';
export const BIG_WINNERS_ONLINE_ID = 'bigWinnerAwareness_Online';
export const BIG_WINNERS_SCRATCH_ID = 'bigWinnerAwareness_Scratch';
export const BIG_WINNERS_ID = 'bigWinnerAwareness';
export const JACKPOT_ID = 'jackpotAwareness';

function downloadHistoryReport(restSrv, model, source, format, filters, retailerNumber = null) {
  let gridModel = {};
  if (source === 'cumulative') {
    gridModel = get(model, 'cumulativeHistory.grid') || {};
  } else if (source === 'netSales') {
    gridModel = get(model, 'netSalesHistory.grid') || {};
  }
  const retailerId = retailerNumber || get(model, 'session.retailer.retailerId', '');
  const locale = get(model, 'session.locale') || '';
  const url = get(model, 'session.rest.widgets.cumulativeHistory.url') || '';

  const queryParams = {
    ...gridModel.pagingModel,
    ...filters.filters,
    ...{ locale },
    pageSize: 0, // BE contract - pageSize = 0 triggers exporting entire data set
  };
  const urlParams = {
    retailerId,
  };
  const headers = appHelpers.setHeader(format);

  return restSrv.downloadBlob(undefined, url, queryParams, urlParams, headers);
}

function getAlertDetails(config, gettextCatalog, type, totalCount, retailerId = null) {
  const { dictionary, contact, session } = DepsService.$ngRedux.getState();
  const { defaultContactPhone: phoneNumber } = contact.lottery;
  const { locale } = session;
  const terms = dictionary.terms[locale];
  const issued = terms.ACTIVE.ISSUED;
  const active = terms.ACTIVE.singular;
  const confirmed = terms.CONFIRMED.singular;
  const lowerCaseConfirmed = terms.CONFIRMED.singularLowerCase;
  const pack = terms.PACK.singular;
  const packs = terms.PACK.plural;
  const lowerCasePack = terms.PACK.singularLowerCase;
  const lowerCasePacks = terms.PACK.pluralLowerCase;

  const alertsCollection = {
    ArwNewGameNotActivatedAlert: {
      /// {{ status }} is a definition describing particular pack status.
      title: gettextCatalog.getString('New Game(s) Not {{ status }}', {
        status: active,
      }),
      subtitle: {
        DEFAULT: gettextCatalog.getString('You have not yet displayed one or more new games.'),
        /// {{ status }} is a definition describing particular pack status.
        CHAIN_HEAD: gettextCatalog.getString('{{ totalCount }} stores in your chain have not yet {{ status }} and displayed new games.', {
          totalCount,
          status: active,
        }),
      },
      /// {{ status }} is a definition describing particular pack status.
      modalTitle: gettextCatalog.getString('New Game(s) Not {{ status }}', {
        status: active,
      }),
      modalSubtitle: {
        DEFAULT: gettextCatalog.getString('Please put the following games out for sale:'),
        /// {{ status }} is a definition describing particular pack status.
        CHAIN_HEAD: gettextCatalog.getString('The following stores have not yet {{ status }} the recently launched games listed below.', {
          status: active,
        }),
      },
    },
    ArwNewGameNotOnDisplayAlert: {
      title: gettextCatalog.getString('New Game(s) Selling Out'),
      subtitle: {
        DEFAULT: gettextCatalog.getString('Based on cashing activity, you are selling out or have sold out of new game(s) on display.'),
        CHAIN_HEAD: gettextCatalog.getString(
          'Based on cashing activity, {{ totalCount }} stores appear to have sold out of new games on display.',
          { totalCount }
        ),
      },
      modalTitle: gettextCatalog.getString('New Game(s) Selling Out'),
      modalSubtitle: {
        DEFAULT: gettextCatalog.getString(
          'Check your inventory on display. You may have sold out of our newest game(s). Please contact {{ phoneNumber }} for additional information.',
          { phoneNumber }
        ),
        CHAIN_HEAD: gettextCatalog.getString(
          'The following stores appear to have sold out of our newest games. Please notify them to check their inventory. Please contact {{ phoneNumber }} for additional information.',
          { phoneNumber }
        ),
      },
    },
    ArwNewGameNeedToBeReorderedAlert: {
      title: gettextCatalog.getString('New Game(s) Need to Be Reordered'),
      subtitle: {
        DEFAULT: gettextCatalog.getString('Based on cashing activity, you appear to be out of stock on one or more new games.'),
        CHAIN_HEAD: gettextCatalog.getString('Based on cashing activity, {{ totalCount }} stores appear to be out of stock of new games.', {
          totalCount,
        }),
      },
      modalTitle: gettextCatalog.getString('New Game(s) Need to Be Reordered '),
      modalSubtitle: {
        DEFAULT: gettextCatalog.getString(
          'Check your inventory on display. You may have sold out of one or more of our newest game(s). Please call {{ phoneNumber }} to replenish your stock.',
          { phoneNumber }
        ),
        CHAIN_HEAD: gettextCatalog.getString(
          'Some of your stores appear to have sold out of our newest games. Please notify them to check their inventory and call {{ phoneNumber }} to replenish their stock of these new games.',
          { phoneNumber }
        ),
      },
    },
    ArwUnconfirmedOrdersAlert: {
      /// {{ status }} is a definition describing particular order status.
      title: gettextCatalog.getString('Not {{ status }} Order(s)', {
        status: confirmed,
      }),
      subtitle: {
        /// {{ status }} is a definition describing particular order status.
        DEFAULT: gettextCatalog.getString('Not {{ status }} orders have been identified for your location.', {
          status: confirmed,
        }),
        /// {{ status }} is a definition describing particular order status.
        CHAIN_HEAD: gettextCatalog.getString('Not {{ status }} orders have been identified for {{ totalCount }} stores in your chain.', {
          totalCount,
          status: confirmed,
        }),
      },
      /// {{ status }} is a definition describing particular order status.
      modalTitle: gettextCatalog.getString('Not {{ status }} Order(s)', {
        status: confirmed,
      }),
      modalSubtitle: {
        /// {{ status }} is a definition describing particular order status.
        DEFAULT: gettextCatalog.getString(
          'Not {{ status }} orders have been identified for your location. ' +
            'Please confirm the order if you have received it. ' +
            'If you do not receive this order or the contents do not match this list, please call {{ phoneNumber }}.',
          {
            phoneNumber,
            status: confirmed,
          }
        ),
        /// {{ status }} is a definition describing particular order status.
        CHAIN_HEAD: gettextCatalog.getString(
          'The following locations have orders that have not been {{ status }} <3 or more> days after they shipped. ' +
            'Please notify these locations either to confirm receipt of their orders or, ' +
            'if the order was not received or the contents do not match this list, to call {{ phoneNumber }}.',
          {
            phoneNumber,
            status: lowerCaseConfirmed,
          }
        ),
      },
    },
    ArwExpiringGamesAlert: {
      title: gettextCatalog.getString('Game End'),
      subtitle: {
        DEFAULT: gettextCatalog.getString('You have stock of games that are due to expire in less than <30> days.'),
        CHAIN_HEAD: gettextCatalog.getString('{{ totalCount }} stores have stock of games that are due to expire in less than <30> days.', {
          totalCount,
        }),
      },
      modalTitle: gettextCatalog.getString('Game End'),
      modalSubtitle: {
        DEFAULT: gettextCatalog.getString(
          'The following games are ending soon. Please prepare to end sales and return any inventory of the games below to the Lottery.'
        ),
        CHAIN_HEAD: gettextCatalog.getString(
          'The following games are ending soon. Please notify your stores to prepare to end sales and return any inventory of the games below to the Lottery.'
        ),
      },
    },
    ArwLVMBinNotSellingAlert: {
      title: gettextCatalog.getString('LVM Bin Not Selling'),
      subtitle: {
        DEFAULT: gettextCatalog.getString('One or more bins in your LVM is either sold out or experiencing an error.'),
      },
      modalTitle: gettextCatalog.getString('LVM Bin Not Selling'),
      modalSubtitle: {
        DEFAULT: gettextCatalog.getString(
          'One of the bins in your vending machine is not dispensing tickets. Please restock or reload the tickets for this bin as soon as possible to avoid lost sales.'
        ),
      },
    },
    ArwKeyGamesNeedToBeReorderedAlert: {
      title: gettextCatalog.getString('Key Game(s) Need to Be Reordered'),
      subtitle: {
        DEFAULT: gettextCatalog.getString('Based on cashing activity, you appear to be out of stock on one or more key games.'),
        CHAIN_HEAD: gettextCatalog.getString('Based on cashing activity, {{ totalCount }} stores appear to be out of stock of key games.', {
          totalCount,
        }),
      },
      modalTitle: gettextCatalog.getString('Key Game(s) Need to Be Reordered'),
      modalSubtitle: {
        DEFAULT: gettextCatalog.getString(
          'Check your inventory on display. You may have sold out of one or more key Lottery game(s). Please call {{ phoneNumber }} to replenish your stock.',
          { phoneNumber }
        ),
        CHAIN_HEAD: gettextCatalog.getString(
          'Some of your stores appear to have sold out of key Lottery games. Please notify them to check their inventory and call {{ phoneNumber }} to replenish their stock of these key games.',
          { phoneNumber }
        ),
      },
    },
    ArwKeyGamesOnDisplaySellingOutOrSoldOutAlert: {
      title: gettextCatalog.getString('Key Game(s) Selling Out'),
      subtitle: {
        DEFAULT: gettextCatalog.getString('Based on cashing activity, you are selling out or have sold out of key game(s) on display.'),
        CHAIN_HEAD: gettextCatalog.getString(
          'Based on cashing activity, {{ totalCount }} stores appear to have sold out of key games on display.',
          { totalCount }
        ),
      },
      modalTitle: gettextCatalog.getString('Key Game(s) Selling Out'),
      modalSubtitle: {
        DEFAULT: gettextCatalog.getString(
          'Check your inventory on display. You may have sold out of some key Lottery game(s). Please contact {{ phoneNumber }} for additional information.',
          { phoneNumber }
        ),
        CHAIN_HEAD: gettextCatalog.getString(
          'The following stores appear to have sold out of key Lottery games. Please notify them to check their inventory. Please contact {{ phoneNumber }} for additional information.',
          { phoneNumber }
        ),
      },
    },
    ArwMandatoryReturnAlert: {
      title: gettextCatalog.getString('Mandatory Return'),
      subtitle: {
        DEFAULT: gettextCatalog.getString('You have stock of games that must be returned immediately.'),
        CHAIN_HEAD: gettextCatalog.getString(
          '{{ totalCount }} stores have stock of games that must be removed from display and returned.',
          { totalCount }
        ),
      },
      modalTitle: gettextCatalog.getString('Mandatory Return'),
      modalSubtitle: {
        /// {{ pack }} and  {{ lowerCasePacks }} are Lottery terms using to determine Packs.
        DEFAULT: gettextCatalog.getString(
          'The following game(s) may no longer be sold and must be returned to the Lottery. Please remove from display immediately. When all {{ lowerCasePacks }} of game(s) listed are removed from display, select “{{ pack }} Removed” button to hide this Alert.',
          { pack: packs, lowerCasePacks }
        ),
        CHAIN_HEAD: gettextCatalog.getString(
          'The following game(s) may no longer be sold and must be returned to the Lottery. Please notify your stores to remove from display immediately.'
        ),
      },
    },
    ArwLicenseRenewalAlert: {
      title: gettextCatalog.getString('Your license will expire soon'),
      subtitle: {
        DEFAULT: gettextCatalog.getString('Your license will expire soon.'),
        CHAIN_HEAD: gettextCatalog.getString('{{ totalCount }} stores have license expiring soon.', { totalCount }),
      },
      modalTitle: gettextCatalog.getString('Your license will expire soon'),
      modalSubtitle: {
        DEFAULT: gettextCatalog.getString('The following stores appear to have License expiring soon'),
      },
    },
    ArwBondRenewalAlert: {
      title: gettextCatalog.getString('Your bond(s) will expire soon'),
      subtitle: {
        DEFAULT: gettextCatalog.getString('Your bond(s) will expire soon.'),
        CHAIN_HEAD: gettextCatalog.getString('{{ totalCount }} stores bond(s) expiring soon.', { totalCount }),
      },
      modalTitle: gettextCatalog.getString('Your bond(s) will expire soon'),
      modalSubtitle: {
        DEFAULT: gettextCatalog.getString('The following stores appear to have Bond(s) expiring soon'),
      },
    },
    ArwAutoActivatedConfirmedAlert: {
      /// {{ pack }} is Lottery term using to determine Pack.
      title: gettextCatalog.getString('Your {{ pack }}(s) was auto-activated', { pack: lowerCasePack }),
      subtitle: {
        /// {{ pack }} is Lottery term using to determine Pack.
        DEFAULT: gettextCatalog.getString('Your {{ pack }}(s) was auto-activated', { pack: lowerCasePack }),
        /// {{ pack }} is Lottery term using to determine Pack.
        CHAIN_HEAD: gettextCatalog.getString('{{ totalCount }} stores have {{ pack }}(s) auto-activated.', {
          totalCount,
          pack: lowerCasePack,
        }),
        /// {{ pack }} is Lottery term using to determine Pack.
        STORE_PROFILE: gettextCatalog.getString('{{ totalCount }} stores have {{ pack }}(s) auto-activated.', {
          totalCount,
          pack: lowerCasePack,
        }),
      },
      /// {{ packs }} is Lottery term using to determine Pack.
      modalTitle: gettextCatalog.getString('{{ packs }} Auto-Activated', { packs }),
      modalSubtitle: {
        /// {{ pack }} is Lottery term using to determine Pack.
        DEFAULT: gettextCatalog.getString(
          'The following {{ pack }} were auto-activated {{ numberOfDays }} days after they were confirmed.',
          { numberOfDays: DepsService.config.ArwAutoActivatedConfirmedAlert.numberOfDays, pack: lowerCasePacks }
        ),
        /// {{ pack }} is Lottery term using to determine Pack.
        CHAIN_HEAD: gettextCatalog.getString(
          'The following stores have {{ pack }} that have been auto-activated {{ numberOfDays }} days after they were confirmed.',
          { numberOfDays: DepsService.config.ArwAutoActivatedConfirmedAlert.numberOfDays, pack: lowerCasePack }
        ),
        /// {{ pack }} is Lottery term using to determine Pack.
        STORE_PROFILE: gettextCatalog.getString(
          'The following {{ pack }} have been auto-activated due to them being in confirmed status for {{ numberOfDays }} days.',
          { numberOfDays: DepsService.config.ArwAutoActivatedConfirmedAlert.numberOfDays, pack: lowerCasePack }
        ),
      },
    },
  };

  const emptyAlert = {
    title: gettextCatalog.getString('Will be implemented soon.'),
    subtitle: {
      INDEPENDENT: gettextCatalog.getString('Will be implemented soon.'),
      CHAIN_SUBORDINATE: gettextCatalog.getString('Will be implemented soon.'),
      CHAIN_HEAD: gettextCatalog.getString('Will be implemented soon.'),
      STORE_PROFILE: gettextCatalog.getString('Will be implemented soon.'),
    },
    modalTitle: gettextCatalog.getString('Will be implemented soon.'),
    modalSubtitle: {
      INDEPENDENT: gettextCatalog.getString('Will be implemented soon.'),
      CHAIN_SUBORDINATE: gettextCatalog.getString('Will be implemented soon.'),
      CHAIN_HEAD: gettextCatalog.getString('Will be implemented soon.'),
      STORE_PROFILE: gettextCatalog.getString('Will be implemented soon.'),
    },
  };

  const gridHeadersData = {
    ArwNewGameNotActivatedAlert: [
      {
        text: gettextCatalog.getString('Game Name'),
      },
      {
        text: gettextCatalog.getString('Game No.'),
        classes: 'text-right',
      },
      {
        text: gettextCatalog.getString('Price Point'),
        classes: 'text-right',
      },
      {
        text: gettextCatalog.getString('Game Launch'),
        classes: 'text-right',
      },
    ],
    ArwNewGameNotOnDisplayAlert: [
      {
        text: gettextCatalog.getString('Game Name'),
      },
      {
        text: gettextCatalog.getString('Game No.'),
        classes: 'text-right',
      },
      {
        text: gettextCatalog.getString('Price Point'),
        classes: 'text-right',
      },
      {
        text: gettextCatalog.getString('Game Launch'),
        classes: 'text-right',
      },
    ],
    ArwNewGameNeedToBeReorderedAlert: [
      {
        text: gettextCatalog.getString('Game Name'),
      },
      {
        text: gettextCatalog.getString('Game No.'),
        classes: 'text-right',
      },
      {
        text: gettextCatalog.getString('Price Point'),
        classes: 'text-right',
      },
      {
        text: gettextCatalog.getString('Game Launch'),
        classes: 'text-right',
      },
    ],
    ArwUnconfirmedOrdersAlert: [
      {
        text: gettextCatalog.getString('Order Contents'),
      },
      {
        text: gettextCatalog.getString('Game Name'),
      },
      {
        text: gettextCatalog.getString('Game No.'),
        classes: 'text-right',
      },
      {
        /// {{ pack }} is Lottery term using to determine Pack.
        text: gettextCatalog.getString('{{ pack }} No.', { pack }),
        classes: 'text-right',
      },
      {
        /// {{ pack }} is Lottery term using to determine Pack, {{ status }} is a definition describing particular pack status.
        text: gettextCatalog.getString('{{ pack }} {{ status }}', { pack: packs, status: issued }),
        classes: 'text-right',
      },
    ],
    ArwExpiringGamesAlert: [
      {
        text: gettextCatalog.getString('Game Name'),
      },
      {
        text: gettextCatalog.getString('Game No.'),
        classes: 'text-right',
      },
      {
        text: gettextCatalog.getString('Price Point'),
        classes: 'text-right',
      },
      {
        /// {{ pack }} is Lottery term using to determine Pack.
        text: gettextCatalog.getString('{{ pack }} No.', { pack }),
        classes: 'text-right',
      },
      {
        text: gettextCatalog.getString('% Validated'),
        classes: 'text-right',
      },
      {
        text: gettextCatalog.getString('Game End Date'),
        classes: 'text-right',
      },
    ],
    ArwLVMBinNotSellingAlert: [
      {
        text: gettextCatalog.getString('LVM ID'),
      },
      {
        text: gettextCatalog.getString('Bin Number'),
      },
    ],
    ArwKeyGamesNeedToBeReorderedAlert: [
      {
        text: gettextCatalog.getString('Game Name'),
      },
      {
        text: gettextCatalog.getString('Game No.'),
        classes: 'text-right',
      },
      {
        text: gettextCatalog.getString('Price Point'),
        classes: 'text-right',
      },
    ],
    ArwKeyGamesOnDisplaySellingOutOrSoldOutAlert: [
      {
        text: gettextCatalog.getString('Game Name'),
      },
      {
        text: gettextCatalog.getString('Game No.'),
        classes: 'text-right',
      },
      {
        text: gettextCatalog.getString('Price Point'),
        classes: 'text-right',
      },
    ],
    ArwMandatoryReturnAlert: [
      {
        text: gettextCatalog.getString('Game Name'),
      },
      {
        text: gettextCatalog.getString('Game No.'),
        classes: 'text-right',
      },
      {
        text: gettextCatalog.getString('Price Point'),
        classes: 'text-right',
      },
      {
        /// {{ pack }} is Lottery term using to determine Pack.
        text: gettextCatalog.getString('{{ pack }} No.', { pack }),
        classes: 'text-right',
      },
    ],
    ArwLicenseRenewalAlert: [
      {
        text: gettextCatalog.getString('License renewal date'),
      },
      {
        text: gettextCatalog.getString('License renewal days left'),
        classes: 'text-right',
      },
    ],
    ArwBondRenewalAlert: [
      {
        text: gettextCatalog.getString('Bond(s) Expiring date'),
      },
      {
        text: gettextCatalog.getString('Bond(s) Expiring days left'),
        classes: 'text-right',
      },
    ],
    ArwAutoActivatedConfirmedAlert: [
      {
        text: gettextCatalog.getString('Game Name'),
      },
      {
        text: gettextCatalog.getString('Game No.'),
        classes: 'text-right',
      },
      {
        /// {{ pack }} is Lottery term using to determine Pack.
        text: gettextCatalog.getString('{{ pack }} No.', { pack }),
        classes: 'text-right',
      },
      {
        text: gettextCatalog.getString('Price'),
        classes: 'text-right',
      },
      {
        /// {{ status }} is a definition describing particular pack status.
        text: gettextCatalog.getString('{{ status }}', { status: confirmed }),
        classes: 'text-right',
      },
      {
        /// {{ status }} is a definition describing particular pack status.
        text: gettextCatalog.getString('{{ status }}', { status: active }),
        classes: 'text-right',
      },
    ],
  };

  let retailerType = '';
  if (get(session, 'retailer.isIndependent') || get(session, 'retailerDashboard.isIndependent')) {
    retailerType = 'INDEPENDENT';
  } else if (get(session, 'retailer.isChainSubordinate') || get(session, 'retailerDashboard.isChainSubordinate')) {
    retailerType = 'CHAIN_SUBORDINATE';
  } else if (get(session, 'retailer.isChainHead') || get(session, 'retailerDashboard.isChainHead')) {
    retailerType = 'CHAIN_HEAD';
  } else if (retailerId !== get(session, 'retailer.retailerId')) {
    retailerType = 'STORE_PROFILE';
  }

  const alertDetails = get(alertsCollection, type) || emptyAlert;

  Object.assign(alertDetails || {}, {
    subtitle: get(alertDetails, `subtitle.${retailerType}`, alertDetails.subtitle.DEFAULT),
    modalSubtitle: get(alertDetails, `modalSubtitle.${retailerType}`, alertDetails.modalSubtitle.DEFAULT),
  });

  return {
    gridHeaders: gridHeadersData[type],
    details: alertDetails,
  };
}

export default {
  downloadHistoryReport,
  getAlertDetails,
};



// WEBPACK FOOTER //
// ./src/modules/dashboard/dashboard-helpers.js